import { User } from './user'
import { BaseModel, BelongsTo, Attribute } from './base-model'

export class Reply extends BaseModel {
  public id       : number
  public content  : string
  @Attribute(Date) public createdAt: Date
  @BelongsTo(User) public user: User
  @BelongsTo(Event) public event: Event
}



// WEBPACK FOOTER //
// ./src/models/reply.ts